/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Copilot_Sync_LabelInputs */



/**
* | output |
* | --- |
* | "Synchronous Mode" |
*
* @param {Compliance_Copilot_Sync_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_copilot_sync_label = /** @type {((inputs?: Compliance_Copilot_Sync_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Copilot_Sync_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Synchroner Modus")
	return /** @type {LocalizedString} */ ("Synchronous Mode")
});